module.exports = __webpack_public_path__ + "img/list_11_zh.eb7833f0.png";